import { OperatorFunction } from "rxjs";
import { filter, map, withLatestFrom, distinctUntilChanged, startWith } from "rxjs/operators";

import { ApiStateStoreState } from "../api-state-store.service";
import { UserService } from "../resources/user/user.service";
import { currentOrganization } from "./current-organization";

import { userId } from "./user-id";

export function domain(): OperatorFunction<ApiStateStoreState, string> {
  return storeState =>
    storeState.pipe(
      withLatestFrom(
        storeState.pipe(userId()),
        // in case current Organization is not initiated, which it won't be for non admin users as they cannot call organizationRead,
        // we need to at least populate the observable with one value so the rest of the pipe works. Hence the startWith(undefined)
        storeState.pipe(currentOrganization(), startWith(undefined)),
        UserService.usersById
      ),
      map(
        ([, selfUserId, currentOrg, usersById]) =>
          currentOrg?.domain || usersById[selfUserId]?.domain
      ),
      filter(<T>(val: T): val is NonNullable<T> => !!val),
      distinctUntilChanged()
    );
}
